import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "./LogIn.css";

const LogInPopups = ({ show, onClose, onSwitchToSignUp, onLoginSuccess }) => {
  const [usernameOrPhone, setUsernameOrPhone] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");

  if (!show) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const res = await fetch("http://localhost:5000/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ usernameOrPhone, password }),
      });

      const data = await res.json();

      if (!data.success) {
        setError(data.message || "Login failed");
      } else {
        // ✅ Save user to localStorage
        localStorage.setItem("user", JSON.stringify(data.user));
        // ✅ Notify NavBar immediately
        window.dispatchEvent(new Event("storage"));

        if (onLoginSuccess) {
          onLoginSuccess(); // handled in TutorialList or AuthPopupManager
        } else {
          onClose();
        }
      }
    } catch (err) {
      setError("Server error. Try again later.");
    }
  };

  return (
    <div className="popup-overlay">
      <div className="popup-box">
        <button className="popup-close" onClick={onClose}>
          ×
        </button>

        <h1 className="logo">Log In</h1>

        <form className="signup-form" onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Username or Phone"
            className="input-field"
            value={usernameOrPhone}
            onChange={(e) => setUsernameOrPhone(e.target.value)}
            required
          />

          <div className="password-wrapper">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              className="input-field"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <span
              className="eye-icon"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>

          {error && <p className="error-text">{error}</p>}

          <button type="submit" className="signup-btn">
            Log In
          </button>
        </form>

        <div className="login-box">
          <p>Don’t have an account?</p>
          <Link
            to="#"
            className="Sign_up_link"
            onClick={(e) => {
              e.preventDefault();
              onSwitchToSignUp();
            }}
          >
            Sign Up
          </Link>
        </div>
      </div>
    </div>
  );
};

export default LogInPopups;
